import React, { useState } from "react";

const ShareButtons = ({ blogUrl, blogTitle }) => {
  const [copied, setCopied] = useState(false);
  const encodedUrl = encodeURIComponent(blogUrl);
  const encodedTitle = encodeURIComponent(blogTitle);

  const handleCopyLink = () => {
    navigator.clipboard.writeText(blogUrl);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="mt-10 flex flex-wrap items-center gap-4 bg-blue-50/30 border border-blue-100 p-4 rounded-lg shadow-sm">
      <span className="flex items-center gap-2 text-sm font-medium text-gray-600">
        <i className="fa-solid fa-bullhorn text-blue-600" />
        Share this blog:
      </span>

      <a
        href={`https://api.whatsapp.com/send?text=${encodedTitle} - ${encodedUrl}`}
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex items-center gap-2 px-4 py-2 text-sm rounded-md font-medium text-white bg-green-500 hover:bg-green-600 transition"
      >
        <i className="fa-brands fa-whatsapp" />
        WhatsApp
      </a>

      <a
        href={`https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`}
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex items-center gap-2 px-4 py-2 text-sm rounded-md font-medium text-white bg-blue-600 hover:bg-blue-700 transition"
      >
        <i className="fa-brands fa-facebook-f" />
        Facebook
      </a>

      <a
        href={`https://twitter.com/intent/tweet?text=${encodedTitle}&url=${encodedUrl}`}
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex items-center gap-2 px-4 py-2 text-sm rounded-md font-medium text-white bg-black hover:bg-gray-800 transition"
      >
        <i className="fa-brands fa-x-twitter" />
        Twitter
      </a>

      <button
        onClick={handleCopyLink}
        className={`inline-flex items-center gap-2 px-4 py-2 text-sm rounded-md font-medium ${
          copied
            ? "bg-blue-100 text-blue-700 border border-blue-300"
            : "bg-white text-gray-700 border border-gray-300 hover:bg-blue-50 hover:text-blue-700"
        } transition`}
      >
        <i className="fa-solid fa-link" />
        {copied ? "Link Copied!" : "Copy Link"}
      </button>
    </div>
  );
};

export default ShareButtons;
